export const ROUTES = {
  //auth
  login: "/",
  register: "/register",
  otpPage: "/password-otp",
  passwordForgot: "/forgot-password",
  passwordSet: "/set-password",
  passwordSetSuccess: "/set-password/success",
  termsAndCondition: "/terms-and-condition",
  passwordChange: "/change-password",
  passwordSetting: "/settings/change-password",
  dashboard: "/dashboard",
  requestNin: "/request-nin",
  guestRequestNin: "/guest/request-nin",
  guestRequestNinSuccess: "/guest/request-nin-success",
  dashboardTerminalStats: "/dashboard/terminal-statistics",
  dashboardOnboardingStats: "/dashboard/onboarding-statistics",

  //agents
  createAgent: "/agent/create",
  viewAgent: "/agent",
  agentManagement: "/agents",

  //terminals
  registerTerminal: "/terminals/register",
  terminalRequests: "/terminals/terminal-requests",
  manageTerminals: "/terminals/manage-terminals",

  terminals: "/terminals",
  requestTerminal: "/terminals/request",
  swapTerminal: "/terminals/swap",

  //users
  createAdminUser: "/users/create",
  manageUsers: "/users/manage-users",
  manageAgents: "/users/manage-agents",

  viewUser: "/users/view-user",
  userProfile: "/profile",
  userGuarantorInfo: "/on-boarding/guarantor",
  agentOnboarding: "/on-boarding",
  agentOnboardingStart: "/on-boarding/start",
  agentOnboardingPending: "/on-boarding/pending",
  onBoardingTANDC: "/on-boarding/terms-and-conditions",

  //roles
  createRole: "/roles/create",
  manageRoles: "/roles",

  //Approvals
  pendingKYC: "/approvals/pending-kyc", //view All
  pendingKYCs: "/approvals/pending-kycs", //view individual

  validatedKYCs: "/approvals/validated-kycs",
  finalApproval: "/approvals/final-approval",
  validatedKYC: "/approvals/validated-kyc",

  adminAccounts: "/approvals/accounts/admin",
  pmAccountsApproval: "/approvals/pm-accounts",

  terminalsAuthorization: "/approvals/register-terminals",
  terminalsMappingApproval: "/approvals/map-terminals",

  rolesAuthorization: "/approvals/roles",

  manageNotifications: "/manage-notifications",

  //Transactions
  transactions: "/transactions",
  reports: "/reports",

  //accounts
  viewPmAccounts: "/pm-accounts",

  notFound: "/404",
};

export const pocketMoniUrl = "https://getpocketmoni.com/";
export const androidDownloadUrl =
  "https://play.google.com/store/apps/details?id=com.pocketmoni.ui&hl=en";
export const iosDownloadUrl =
  "https://apps.apple.com/ng/app/pocketmoni-ng/id1207305721";
export const fileBaseURL = `${process.env.REACT_APP_UPLOAD_URL}/file/download`;
